<template>
    <v-autocomplete
            v-model="model"
            :items="items"
            item-text="name"
            item-value="id"
            hide-details
            filled
            :label="label || 'Estado' + (isMultiple ? 's' : '')"
            prepend-inner-icon="fas fa-info-circle"
            return-object
            :multiple="isMultiple"
            :disabled="loading || disabled"
            :required="isRequired"
            @blur="onBlur"
    >
        <template v-if="isMultiple" v-slot:selection="{ item, index }">
            <v-chip small v-if="index === 0">
                <span>{{ item.name }}</span>
            </v-chip>
            <span
                    v-if="index === 1"
                    class="grey--text caption"
            >({{ model.length - 1 }}+)</span>
        </template>

        <template slot="no-data">
               <span class="caption pa-2">No se han encontrado estados</span>
        </template>

    </v-autocomplete>
</template>

<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {filterSelectorWithHeaders, filterUniqueIds} from '@/utils/Common'
    import {mapMutations, mapState} from 'vuex'

    export default{
        props: [
            'default',
            'multiple',
            'required' ,
            'label',
            'disabled',
            'value',
            'type'
        ],
        data(){
            return {
                model: this.isMultiple ? [] : null,
                statuses: [],
                loading: false
            }
        },
        watch: {
            statuses(val){
                var vm = this
                vm.model = vm.statuses.length ? (vm.isMultiple ? [vm.defaultStatus] : vm.defaultStatus) : null
            },
            service(val){
                this.getSpecialists()
            },
            model(val, oldVal){
                var vm = this
                vm.$emit('change', val)
                if(!val || val.length === 0) this.model = vm.isMultiple  ? oldVal.slice() : oldVal
            },
            value(val){
                if(val){
                    this.model = val
                }
            }
        },
        async mounted(){
            await this.getStatuses()
        },
        methods: {
            ...mapMutations(['showSnackBar', 'setEventStatuses']),
            onBlur(){
                var vm = this
                vm.$emit('blur', JSON.parse(JSON.stringify(vm.model)))
            },
            filter: (item, queryText, itemText) => {
            },
            clear(){
                this.model = this.isMultiple ? [] : null
            },
            async getStatuses(){

                var vm = this

                if(vm.eventStatuses.length > 0) {
                    vm.statuses = vm.eventStatuses.slice()
                    vm.$emit('loaded', vm.eventStatuses.slice())
                    return
                }

                var url = `public/schedule/events/statuses`

                vm.loading = true
                var response = await ApiUtils.makeGet(url)
                vm.loading = false

                if (!response.ok) {
                    vm.showSnackBar('Ha ocurrido un error consultando estados')
                    return
                }

                const json = await response.json()
                vm.setEventStatuses(json.result.statuses)
                vm.statuses = json.result.statuses
                vm.$emit('loaded',  json.result.statuses.slice())


            }
        },
        computed: {
                ...mapState(['currentBranchOffice', 'currentProvider', 'currentUser', 'eventStatuses']),
            isMultiple(){
                return this.multiple != undefined && this.multiple !== false
            },

            defaultStatus(){
                var vm = this
                if(!vm.statuses || vm.statuses.length === 0) return null
                return vm.statuses[0]
            },

            isRequired(){
              return this.required != undefined && this.required !== false
            },

            items(){

                var vm = this
                var all = []

                if(!vm.statuses.length) return all

                var statuses = vm.statuses

                statuses.forEach((status) => {
                    all.push({
                        id: status.id,
                        name: status.name,
                    })
                })

                return all

            }
        },
    }
</script>
